<template>
  <div :id="localId"></div>
</template>

<script>
import mx_Core from './includes/mixins/zMixins'    // Global & Local Mixins

export default {
  name: "j-chart-submenu-01",
  mixins: [mx_Core],
  props: {
    id: String,
    modeService: Boolean,

    EnvValues: {
      type: Object,
      default: () => ({
        tab: 'B1'
      })
    },
    FilterValues: {
      type: Object,
      default: () => ({
        MOD: '41M001'
      })
    },
    
    // Chart Data
    Canvas: { type: Object, default: () => ({}) },
    DataItems: { type: Array, default: () => ([]) },

    values: {
      type: Object,
      default: () => ({
        milestone: [],
      })
    }
  },
  created() {
    this.localId = `${this.id || 'j-chart-custom'}__${this.safeId('')}`
  },
  mounted() {
    this.register(this.draw)
  },

  methods: {
    draw() {
      // Check all the necessary values are available
      if (!this.modeService && !this.ready2draw) return

      this.clear()
      this.setDefaultValues()
      this.drawCanvas()
      this.drawMenusOption()
      
      this.complete()
    },


  }
}
</script>